import React from 'react';
import {
    Route,
    Switch,
    HashRouter,
  } from 'react-router-dom';
import './App.css';
import asyncComponent from "./components/AsyncComponent.js";
import i18n from './i18n';
import { getQueryVariable } from './util/common'

const BindInviteCode = asyncComponent(()=> import('./container/BindScreen/BindInviteCode'))
const DownloadWallet = asyncComponent(()=> import('./container/DownloadWallet/DownloadWallet'))
const XinKeDownload = asyncComponent(()=> import('./container/XinKeDownload/XinKeDownload'))
const HomeScreen = asyncComponent(()=> import('./container/HomeScreen'))
const XinKeMall = asyncComponent(()=> import('./container/XinKeMall/XinKeMall'))
const XinkeLogin = asyncComponent(()=> import('./container/XinkeLogin/XinkeLogin/XinkeLogin'))
const XinkeRegister = asyncComponent(()=> import('./container/XinkeLogin/XinkeRegister/XinkeRegister'))
const TinkNewRegister = asyncComponent(()=> import('./container/XinkeLogin/TinkNewRegister/TinkNewRegister'))
const commonProblem = asyncComponent(()=> import('./container/XinkeLogin/commonProblem/commonProblem'))
const commonProblemDetail = asyncComponent(()=> import('./container/XinkeLogin/commonProblemDetail/commonProblemDetail'))
const XinkeForgetPassword = asyncComponent(()=> import('./container/XinkeLogin/XinkeForgetPassword/XinkeForgetPassword'))
const XinKeEcharts = asyncComponent(()=> import('./container/XinKeEcahrts'))
const TinkActivitySrceen = asyncComponent(()=> import('./container/TinkActivitySrceen'))
const OpenDemo = asyncComponent(()=> import('./container/OpenDemo/index'))
const Explore = asyncComponent(()=> import('./container/Explore/index'))
const TukeExplore = asyncComponent(()=> import('./container/TukeExplore/index'))
const WalletPosEcharts = asyncComponent(()=> import('./container/WalletPosEcharts/index'))




global.$lan = i18n.t;

let lang = getQueryVariable('lang')
i18n.changeLanguage(lang || 'zh');


function App() {
    return (
        <div className="App">
            <HashRouter>
                <Switch>
                    <Route path="/" exact component={HomeScreen}/>
                    <Route path="/thinkey" component={BindInviteCode}/>
                    <Route path="/download" component={DownloadWallet}/>
                    <Route path="/xinkedownload" component={XinKeDownload}/>
                    <Route path="/xinkemall" component={XinKeMall}/>
                    <Route path="/XinkeLogin" component={XinkeLogin}/>
                    <Route path="/XinkeRegister" component={XinkeRegister}/>
                    <Route path="/TinkNewRegister" component={TinkNewRegister}/>
                    <Route path="/commonProblem" component={commonProblem}/>
                    <Route path="/commonProblemDetail" component={commonProblemDetail}/>
                    {/* <Route path="/Demo" component={Demo}/> */}
                    <Route path="/XinkeForgetPassword" component={XinkeForgetPassword}/>
                    <Route path="/XinKeEcharts" component={XinKeEcharts}/>
                    <Route path="/tinkActivity" component={TinkActivitySrceen}/>
                    <Route path="/OpenDemo" component={OpenDemo}/>
                    <Route path="/Explore" component={Explore}/>
                    <Route path="/TukeExplore" component={TukeExplore}/>
                    <Route path="/WalletPosEcharts" component={WalletPosEcharts}/>
                </Switch>
            </HashRouter>
        </div>
    );
}

export default App;
